/**
 * theme-sections.js
 * JavaScript for all custom theme sections
 * Requires: jQuery, OWL Carousel 2
 */

(function ($) {
  'use strict';

  /* ══════════════════════════════════════════════
     Counter Animation for Stats Section
  ══════════════════════════════════════════════ */
  function tsAnimateCounters() {
    var counters = document.querySelectorAll('.ts-stats__number');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var raw = el.textContent.replace(/[^0-9.]/g, '');
          var suffix = el.textContent.replace(/[0-9.]/g, '');
          var target = parseFloat(raw);
          if (isNaN(target)) return;

          var start = 0;
          var duration = 1800;
          var startTime = null;

          function step(ts) {
            if (!startTime) startTime = ts;
            var progress = Math.min((ts - startTime) / duration, 1);
            var ease = 1 - Math.pow(1 - progress, 3);
            var current = Math.floor(ease * target);
            el.textContent = current + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }

          requestAnimationFrame(step);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function (c) { observer.observe(c); });
  }

  /* ══════════════════════════════════════════════
     Hero Parallax (subtle bg shift on scroll)
  ══════════════════════════════════════════════ */
  function tsHeroParallax() {
    var heroBgs = document.querySelectorAll('.ts-hero__bg');
    if (!heroBgs.length) return;

    window.addEventListener('scroll', function () {
      var scrollY = window.pageYOffset;
      heroBgs.forEach(function (bg) {
        bg.style.transform = 'translateY(' + (scrollY * 0.25) + 'px)';
      });
    }, { passive: true });
  }

  /* ══════════════════════════════════════════════
     Scroll Reveal (fade in sections on scroll)
  ══════════════════════════════════════════════ */
  function tsScrollReveal() {
    var revealEls = document.querySelectorAll([
      '.ts-product-card',
      '.ts-collections__card',
      '.ts-about__feature-item',
      '.ts-faq__item',
      '.ts-testimonials__card',
      '.ts-stats__item',
      '.ts-showcase-grid__item',
      '.ts-showcase-split__product-item'
    ].join(','));

    if (!('IntersectionObserver' in window)) return;

    revealEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease ' + (i % 4 * 0.08) + 's, transform 0.5s ease ' + (i % 4 * 0.08) + 's';
    });

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ══════════════════════════════════════════════
     Announcement Bar Pause on Hover
  ══════════════════════════════════════════════ */
  function tsAnnouncementHover() {
    document.querySelectorAll('.ts-announcement').forEach(function (bar) {
      var track = bar.querySelector('.ts-announcement__track');
      if (!track) return;
      bar.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      bar.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  }

  /* ══════════════════════════════════════════════
     Newsletter Form Success Feedback
  ══════════════════════════════════════════════ */
  function tsNewsletterFeedback() {
    document.querySelectorAll('[id^="tsNewsletterForm"]').forEach(function (form) {
      if (!form) return;
      // Shopify handles form submission — check for success param
      if (window.location.search.indexOf('customer_posted=true') !== -1) {
        var input = form.querySelector('.ts-newsletter__input');
        var btn = form.querySelector('.ts-newsletter__submit');
        if (input) input.value = '';
        if (btn) btn.textContent = 'Subscribed! ✓';
      }
    });
  }

  /* ══════════════════════════════════════════════
     Init All on DOM Ready
  ══════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    tsAnimateCounters();
    tsHeroParallax();
    tsScrollReveal();
    tsAnnouncementHover();
    tsNewsletterFeedback();
  });

})(jQuery);
